var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "device-setting-info-component",
      class: _vm.roomInfo.roomType,
    },
    [
      _c("div", { staticClass: "device-setting-info" }, [
        _c("div", { staticClass: "device-set-info" }, [
          _c("div", { staticClass: "device-set-info-header pc" }, [
            _c("button", {
              staticClass: "back-btn",
              on: { click: _vm.handleClickBackBtn },
            }),
          ]),
          _vm.isShowInfo
            ? _c("div", { staticClass: "device-set-info-body" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.onToggleInfo,
                        expression: "onToggleInfo",
                      },
                    ],
                    staticClass: "device-set-info-title-container",
                  },
                  [
                    _c("div", { staticClass: "device-set-info-room-type" }, [
                      _c(
                        "h2",
                        { staticClass: "device-set-info-room-type-text" },
                        [_vm._v(_vm._s(_vm.roomType))]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "device-set-info-title-wrapper" },
                      [
                        _c("p", { staticClass: "device-set-info-title" }, [
                          _vm._v(_vm._s(_vm.roomInfo.roomTitle)),
                        ]),
                      ]
                    ),
                    _vm.noPermission
                      ? _c("div", [
                          _c("p", { staticClass: "device-set-info-check" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "deviceSetting.info.waiting.error.permission"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm.noManagerInRoom
                      ? _c("div", [
                          _c("p", { staticClass: "device-set-info-check" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "deviceSetting.info.waiting.error.noManager"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm.roomClosed
                      ? _c("div", [
                          _c("p", { staticClass: "device-set-info-check" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "deviceSetting.info.waiting.error.closed"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm.disapproved
                      ? _c("div", [
                          _c("p", { staticClass: "device-set-info-check" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "deviceSetting.info.waiting.error.rejected"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _c(
                          "div",
                          { staticClass: "device-set-info-check-wrapper" },
                          [
                            _c("p", {
                              staticClass:
                                "device-set-info-check roomDescription",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "deviceSetting.info.waiting.deviceTest"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                    _c(
                      "div",
                      { staticClass: "device-set-info-check-wrapper" },
                      [
                        _c("p", {
                          staticClass: "device-set-info-check roomDescription",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("deviceSetting.info.waiting.noMic")
                            ),
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "device-set-info-footer pc" }, [
            _c("div", { staticClass: "device-set-join-btn-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "default-btn join-request-btn",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("reqApproveJoin")
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.disapproved || _vm.noManagerInRoom || _vm.roomClosed
                          ? _vm.$t("deviceSetting.preview.toHome")
                          : _vm.enterRequested
                          ? _vm.$t("deviceSetting.preview.join.requested")
                          : _vm.$t("deviceSetting.preview.join.request")
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "default-btn home",
                  attrs: { href: "/service/room", target: "_top" },
                },
                [_vm._v(_vm._s(_vm.$t("deviceSetting.preview.toHome")))]
              ),
              _vm._m(0),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "loading-obj-group" }, [
      _c("li", { staticClass: "loading-obj obj-1" }),
      _c("li", { staticClass: "loading-obj obj-2" }),
      _c("li", { staticClass: "loading-obj obj-3" }),
      _c("li", { staticClass: "loading-obj obj-4" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }